import { makeStyles } from '@material-ui/core';
import logoFull from '../../assets/branding/logo-full.png';

const useStyles = makeStyles({
  image: {
    width: 'auto',
    height: 70,
    display: 'block',
  },
});

export const LogoFull = () => {
  const classes = useStyles();

  return <img className={classes.image} src={logoFull} alt="RDAP" />;
};
